"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("../styled-components");
const FlatButton_1 = require("./FlatButton");
const Cross_1 = __importDefault(require("../Icons/Cross"));
const LittleButton = (0, styled_components_1.styled)(FlatButton_1.FlatButton) `
  min-width: 20px;
  width: 20px;
  height: 20px;
  padding: 0;
  color: ${({ theme }) => theme.icon};
  &:disabled {
    opacity: 0.6;
  }
`;
const CloseButton = ({ disabled, title, margin = "0", onClick, fill, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(LittleButton, { disabled: disabled, onClick: onClick, style: { margin } },
        react_1.default.createElement(Cross_1.default, { fill: fill !== null && fill !== void 0 ? fill : "currentcolor", title: title ? title : t("button-Close") })));
};
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.js.map